import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { EnvelopeSimple, Check } from '@phosphor-icons/react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const ROWS = [
  { key: 'weekly_blog_ready', label: 'Weekly blog post ready',     hint: 'A polished post in your inbox every Monday, ready to publish.' },
  { key: 'marketing_tips',    label: 'Marketing tips from ScalitOS', hint: 'Short, founder-grade notes — once a week, max.' },
  { key: 'product_updates',   label: 'Product updates',             hint: 'New features, improvements, and what we shipped.' },
];

const Toggle = ({ on, onClick, testId }) => (
  <button onClick={onClick} data-testid={testId}
    aria-pressed={on}
    style={{
      position: 'relative', width: 38, height: 22, borderRadius: 999,
      background: on ? '#c8f060' : 'rgba(255,255,255,0.08)',
      border: '1px solid ' + (on ? 'rgba(200,240,96,0.4)' : 'rgba(255,255,255,0.12)'),
      cursor: 'pointer', transition: 'background 0.18s, border 0.18s',
    }}>
    <span style={{
      position: 'absolute', top: 2, left: on ? 18 : 2,
      width: 16, height: 16, borderRadius: 999,
      background: on ? '#0a0a0a' : '#f5f0e8',
      transition: 'left 0.18s',
    }} />
  </button>
);

const EmailPreferencesSection = () => {
  const [prefs, setPrefs] = useState(null);
  const [savingKey, setSavingKey] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/user/email-prefs`);
        setPrefs(data);
      } catch { setPrefs({}); }
    })();
  }, []);

  const toggle = async (key) => {
    if (!prefs) return;
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    setSavingKey(key);
    try {
      await axios.put(`${API}/api/user/email-prefs`, { [key]: next[key] });
      toast.success('Preferences updated');
    } catch {
      setPrefs(prefs); // revert
      toast.error('Could not update preference');
    } finally {
      setSavingKey(null);
    }
  };

  if (!prefs) return null;

  return (
    <div id="email-prefs" data-testid="email-prefs-section"
      style={{
        background: '#141414', border: '1px solid rgba(255,255,255,0.06)',
        borderRadius: 14, padding: 24, marginBottom: 20,
      }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
        <EnvelopeSimple size={18} weight="duotone" style={{ color: '#c8f060' }} />
        <h3 style={{ fontFamily: "'Instrument Serif', serif", fontSize: 20, color: '#f5f0e8', margin: 0 }}>
          Email Notifications
        </h3>
      </div>
      <p style={{ fontSize: 13, color: 'rgba(245,240,232,0.4)', margin: '0 0 18px' }}>
        Choose what ScalitOS sends to your inbox.
      </p>
      <div>
        {ROWS.map((r, idx) => (
          <div key={r.key} data-testid={`email-pref-${r.key}`}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '14px 0', gap: 16,
              borderBottom: idx < ROWS.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
            }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: 14, color: '#f5f0e8', fontWeight: 500, margin: 0 }}>{r.label}</p>
              <p style={{ fontSize: 12, color: 'rgba(245,240,232,0.4)', margin: '2px 0 0', lineHeight: 1.45 }}>{r.hint}</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {savingKey === r.key && <Check size={12} style={{ color: '#c8f060' }} weight="bold" />}
              <Toggle on={!!prefs[r.key]} onClick={() => toggle(r.key)} testId={`email-pref-toggle-${r.key}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailPreferencesSection;
